import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFileZip: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconFileZip"><Path d="M13.25 2.75H7.75C6.09315 2.75 4.75 4.09315 4.75 5.75V18.25C4.75 19.9069 6.09315 21.25 7.75 21.25H16.25C17.9069 21.25 19.25 19.9069 19.25 18.25V8.75M13.25 2.75V5.75C13.25 7.40685 14.5931 8.75 16.25 8.75H19.25M13.25 2.75C13.5701 2.75 13.8772 2.87718 14.1036 3.10355L18.8964 7.89645C19.1228 8.12282 19.25 8.42986 19.25 8.75M8.75 19V17.5M10.25 17.5V16M8.75 16V14.5M10.25 20.5V19M10.25 14.5V13M8.75 13V11.5" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
});

export default IconFileZip;
